export default __webpack_public_path__ + "static/media/lights.919491b7.png";